/* eslint-disable no-unused-vars */
import installGlobalComponents from "./components/installGlobalComponents";
import installBaseComponents from "./components/installBaseComponents";

export default {
    install(Vue, options) {
        // Components
        if (options && options.installAll === true) {
            installBaseComponents(); // to get the extras
            installGlobalComponents(); // get the rest
        } else {
            installBaseComponents();
        }
    },
};
